import React, { useState } from "react";
import { CalendarIcon, FilterModalIcon } from "assets/iconsSVG";
import { ptBR } from "date-fns/locale";
import materialUI from "material-UI";
import { DivisorContainer } from "components/divisorContainer";
import CurrencyFormat from "react-currency-format";
import { InputAdornment, Skeleton } from "@mui/material";
import CheckboxComponent from "components/CheckBoxG";
import SelectAutoComplete from "components/selectAutoCompleteG";
import { BooleanOptions } from "screens/perfilAutonomo/utils";
import { SelectComponent } from "screens/perfilAutonomo/components/SelectComponent";
import * as S from "./styles";
import {
  defaultFiltrosUnidade,
  FiltrosUnidade,
  FiltrosUnidadeEnvio,
} from "./utils";
import { fetchRevendaStatus } from "../api/getRevendaStatus";
import { fetchRevendaEmpreendimentosListar } from "../api/postRevendaEmpreendimentoListar";
import { fetchRevendaAreaUtil } from "../api/getRevendaAreaUtil";
import { fetchRevendaRegiao } from "../../empreendimento/api/postRevendaRegiaoListar";
import { NumberOptions } from "../novaRevenda/utils";

export const FiltroUnidadesRevenda = ({
  open,
  handleFilters,
  onClose,
  authToken,
}: {
  open: boolean;
  handleFilters: (filters: FiltrosUnidadeEnvio) => void;
  onClose: () => void;
  authToken: string;
}) => {
  const [filters, setFilters] = useState<FiltrosUnidade>(defaultFiltrosUnidade);

  const { data: statusOptions, isLoading: loadingStatus } = fetchRevendaStatus({
    enabled: open,
    authToken,
  });
  const { data: empreendimentoOptions, isLoading: loadingEmpreendimentos } =
    fetchRevendaEmpreendimentosListar({ enabled: open, authToken });
  const { data: areaOptions, isLoading: loadingArea } = fetchRevendaAreaUtil({
    enabled: open,
    authToken,
  });
  const { data: regiaoOptions, isLoading: loadingRegiao } = fetchRevendaRegiao(
    authToken,
    open
  );

  const handleClearFilters = () => {
    setFilters(defaultFiltrosUnidade);
  };

  const handleFilter = () => {
    const newFilters: FiltrosUnidadeEnvio = {
      ...filters,
      metragemDe: filters.metragemDe ? Number(filters.metragemDe) : null,
      metragemAte: filters.metragemAte ? Number(filters.metragemAte) : null,
      valorDe: filters.valorDe ? Number(filters.valorDe) : null,
      valorAte: filters.valorAte ? Number(filters.valorAte) : null,
    };
    handleFilters(newFilters);
    onClose();
  };

  return (
    <>
      <S.HeaderModal>
        <FilterModalIcon />
        <S.HeaderModalTitle>Filtros</S.HeaderModalTitle>
        <S.ClearBtn onClick={handleClearFilters}>Limpar campos</S.ClearBtn>
      </S.HeaderModal>
      <S.ContentModal>
        <S.LabelModal>Filtrar por</S.LabelModal>
        <materialUI.RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          value={String(filters.isDataCriacao)}
          name="radio-buttons-group"
          row
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setFilters((prev) => ({
              ...prev,
              isDataCriacao: e.target.value === "true",
            }));
          }}
        >
          <S.FormControlLabel
            value="true"
            control={<S.Radio />}
            label="Data criação"
          />
          <S.FormControlLabel
            value="false"
            control={<S.Radio />}
            label="Data atualização"
          />
        </materialUI.RadioGroup>

        <S.LocalizationProvider
          locale={ptBR}
          dateAdapter={materialUI.AdapterDateFns}
        >
          <S.Row>
            <S.ContentDate>
              <S.DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                value={filters?.dataInicio}
                components={{
                  OpenPickerIcon: CalendarIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) =>
                  setFilters((prev) => ({ ...prev, dataInicio: newValue }))
                }
                renderInput={(params: any) => (
                  <>
                    <S.LabelText>De</S.LabelText>
                    <S.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="De"
                      fullWidth
                    />
                  </>
                )}
              />
            </S.ContentDate>
            <S.ContentDate>
              <S.DesktopDatePicker
                disabled={
                  filters?.dataInicio ? filters.dataInicio > new Date() : false
                }
                inputFormat="dd/MM/yyyy"
                value={filters?.dataFim}
                components={{
                  OpenPickerIcon: CalendarIcon,
                }}
                InputAdornmentProps={{ position: "start" }}
                onChange={(newValue: any) =>
                  setFilters((prev) => ({ ...prev, dataFim: newValue }))
                }
                minDate={filters?.dataInicio ?? undefined}
                renderInput={(params: any) => (
                  <>
                    <S.LabelText>Até</S.LabelText>
                    <S.TextField
                      size="small"
                      InputLabelProps={{ shrink: false }}
                      variant="outlined"
                      {...params}
                      label="Até"
                      fullWidth
                      helperText={
                        filters?.dataInicio && filters.dataInicio > new Date()
                          ? "Data inválida"
                          : ""
                      }
                    />
                  </>
                )}
              />
            </S.ContentDate>
          </S.Row>
        </S.LocalizationProvider>

        <S.LabelText>{"Minhas indicações"}</S.LabelText>
        <SelectComponent
          data={BooleanOptions}
          onChange={(val: boolean) => {
            setFilters((prev) => ({
              ...prev,
              minhasIndicacoes: val,
            }));
          }}
          clearIcon
          placeholder=""
          value={filters.minhasIndicacoes}
          renderLabel
        />

        <S.LabelText>{"Mobiliado"}</S.LabelText>
        <SelectComponent
          data={BooleanOptions}
          onChange={(val: boolean) => {
            setFilters((prev) => ({
              ...prev,
              mobiliado: val,
            }));
          }}
          clearIcon
          placeholder=""
          value={filters.mobiliado}
          renderLabel
        />

        <S.LabelText>{"Empreendimento"}</S.LabelText>
        <SelectAutoComplete
          data={
            empreendimentoOptions?.map((item: any) => ({
              value: item?.id,
              label: item?.nome,
            })) ?? []
          }
          onChange={(val: { label: string; value: string }) => {
            setFilters((prev) => ({
              ...prev,
              idRevendaEmpreendimento: val?.value ?? "",
            }));
          }}
          value={
            empreendimentoOptions
              ?.map((item: any) => ({
                value: item?.id,
                label: item?.nome,
              }))
              ?.find(
                (item: any) => item?.value === filters.idRevendaEmpreendimento
              ) ?? ""
          }
          disabled={
            loadingEmpreendimentos || empreendimentoOptions?.length === 0
          }
        />

        <S.LabelText>{"Torre"}</S.LabelText>
        <SelectComponent
          data={
            filters.idRevendaEmpreendimento
              ? empreendimentoOptions
                  ?.find(
                    (item: any) => item?.id === filters.idRevendaEmpreendimento
                  )
                  ?.revendaEmpreendimentoTorres?.map((item: any) => ({
                    value: item?.id,
                    label: item?.descricao,
                  }))
              : []
          }
          onChange={(val: string) => {
            setFilters((prev) => ({
              ...prev,
              idRevendaEmpreendimentoTorre: val ?? "",
            }));
          }}
          value={filters.idRevendaEmpreendimentoTorre}
          disabled={!filters.idRevendaEmpreendimento}
          placeholder=""
          clearIcon
          renderLabel
        />

        <S.Grid>
          <div>
            <S.LabelText>{"Vagas"}</S.LabelText>
            <SelectComponent
              data={NumberOptions}
              onChange={(val: number) => {
                setFilters((prev) => ({
                  ...prev,
                  vagas: val ?? null,
                }));
              }}
              value={filters?.vagas}
              placeholder=""
              clearIcon
              renderLabel
            />
          </div>
          <div>
            <S.LabelText>{"Área útil"}</S.LabelText>
            <SelectComponent
              data={areaOptions ?? []}
              onChange={(val: number) => {
                setFilters((prev) => ({
                  ...prev,
                  areaUtil: val ?? null,
                }));
              }}
              value={filters?.areaUtil}
              disabled={
                !areaOptions || loadingArea || areaOptions?.length === 0
              }
              placeholder=""
              clearIcon
              renderLabel
            />
          </div>
        </S.Grid>

        <S.LabelText>{"Região"}</S.LabelText>
        <SelectComponent
          data={
            regiaoOptions?.map((item: any) => ({
              value: item?.id,
              label: item?.nome,
            })) ?? []
          }
          onChange={(val: string) => {
            setFilters((prev) => ({
              ...prev,
              idRevendaRegiao: val ?? "",
            }));
          }}
          value={filters.idRevendaRegiao ?? ""}
          disabled={
            !regiaoOptions || loadingRegiao || regiaoOptions?.length === 0
          }
          placeholder=""
          clearIcon
          renderLabel
        />

        <DivisorContainer>
          <S.LabelModal style={{ margin: "25px 0" }}>{"Metragem"}</S.LabelModal>
        </DivisorContainer>

        <S.Grid>
          <div>
            <S.LabelText>{"De"}</S.LabelText>
            <CurrencyFormat
              customInput={S.TextField}
              value={filters?.metragemDe}
              onValueChange={(values) =>
                setFilters((prev) => ({ ...prev, metragemDe: values.value }))
              }
              variant="outlined"
              thousandSeparator="."
              decimalSeparator=","
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">{"m2"}</InputAdornment>
                ),
              }}
            />
          </div>
          <div>
            <S.LabelText>{"Até"}</S.LabelText>
            <CurrencyFormat
              customInput={S.TextField}
              value={filters?.metragemAte}
              onValueChange={(values) =>
                setFilters((prev) => ({ ...prev, metragemAte: values.value }))
              }
              variant="outlined"
              thousandSeparator="."
              decimalSeparator=","
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">{"m2"}</InputAdornment>
                ),
              }}
            />
          </div>
        </S.Grid>

        <DivisorContainer>
          <S.LabelModal style={{ margin: "25px 0" }}>{"Valor"}</S.LabelModal>
        </DivisorContainer>

        <S.Grid>
          <div>
            <S.LabelText>{"De"}</S.LabelText>
            <CurrencyFormat
              customInput={S.TextField}
              value={filters?.valorDe}
              onValueChange={(values) =>
                setFilters((prev) => ({ ...prev, valorDe: values.value }))
              }
              variant="outlined"
              thousandSeparator="."
              decimalSeparator=","
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">{"R$"}</InputAdornment>
                ),
              }}
            />
          </div>
          <div>
            <S.LabelText>{"Até"}</S.LabelText>
            <CurrencyFormat
              customInput={S.TextField}
              value={filters?.valorAte}
              onValueChange={(values) =>
                setFilters((prev) => ({ ...prev, valorAte: values.value }))
              }
              variant="outlined"
              thousandSeparator="."
              decimalSeparator=","
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">{"R$"}</InputAdornment>
                ),
              }}
            />
          </div>
        </S.Grid>

        <DivisorContainer>
          <S.LabelModal style={{ margin: "25px 0" }}>
            {"Status da Reserva"}
          </S.LabelModal>
        </DivisorContainer>

        {loadingStatus ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: 20,
              width: "100%",
            }}
          >
            <Skeleton variant="rectangular" width={"100%"} height={30} />
            <Skeleton variant="rectangular" width={"100%"} height={30} />
            <Skeleton variant="rectangular" width={"100%"} height={30} />
            <Skeleton variant="rectangular" width={"100%"} height={30} />
          </div>
        ) : (
          <S.Grid style={{ gap: 0 }}>
            {statusOptions?.map(
              ({ label, value }: { label: string; value: number }) => (
                <CheckboxComponent
                  key={value}
                  label={label}
                  checked={filters?.status?.includes(value)}
                  onChange={(e) =>
                    setFilters((prev) => ({
                      ...prev,
                      status: e.target.checked
                        ? [...prev.status, value]
                        : prev.status.filter((status) => status !== value),
                    }))
                  }
                />
              )
            )}
          </S.Grid>
        )}
      </S.ContentModal>

      <S.FooterModal>
        <S.Button disabled={false} onClick={handleFilter}>
          Aplicar filtro
        </S.Button>
      </S.FooterModal>
    </>
  );
};
